















































































































import { Component, Mixins } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import AuthModule from '@/store/modules/Auth';
import MarketingModule from '@/store/modules/Marketing';
import Table from '@/components/Table/Index.vue';
import Breadcrumb from '@/components/Breadcrumb.vue';
import Pagination from '@/components/Pagination.vue';
import ManageMixin from '@/mixins/Manage.vue';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';
import FeatureData from '@/data/FeatureData';
import FeatureBody from '@/components/Table/FeatureBody.vue';

@Component({
  components: {
    Table,
    Breadcrumb,
    Pagination,
    FeatureBody,
  },
  mixins: [ManageMixin],
})
export default class FeatureView extends Mixins(ManageMixin, ErrorHandleMixin) {
  AuthInstance = getModule(AuthModule, this.$store);

  MarketingInstance = getModule(MarketingModule, this.$store)

  TableHeadMember = [...FeatureData.TableHeadFeature];

  LoginName = '';

  selfFeature = false;

  userId = '';

  _id = '';

  username = '';

  source = this.AuthInstance.user.source;

  searchUsername = '';

  role = 'All';

  startCount = 1;

  PaginationDetail = {
    page: 1,
    amount: 0,
    limit: 100,
  };

  BreadcrumbList: any = [];

  BreadcrumbDefault = [
    {
      username: this.AuthInstance.user.username,
      source: this.AuthInstance.user.source,
      role: this.AuthInstance.user.role,
      userId: this.AuthInstance.user._id,
    },
  ];

  async created() {
    const resSelf = await this.MarketingInstance.Fetch();
    this.selfFeature = resSelf[0].isFeature;
    await this.fetchUsers();
  }

  submit() {
    this.PaginationDetail.page = 1;
    this.fetchUsers();
  }

  async handleFeature() {
    this.GeneralInstance.toggleLoading(true);
    const { _id } = this.modalData.Feature;
    const res = await this.MarketingInstance.FeatureUpdate({
      _id,
      username: this.modalData.username,
      isStatus: this.modalData.statusFeature,
      parent: this.modalData.parent,
      selfFeature: this.selfFeature,
    });
    if (res.code) {
      this.checkError(res);
    }
    const resSelf = await this.MarketingInstance.Fetch();
    this.selfFeature = resSelf[0].isFeature;
    this.modal.isFeature = false;
    this.checkError(res.status);
    this.GeneralInstance.toggleLoading(false);
    this.fetchUsers();
  }

  async fetchUsers() {
    const {
      PaginationDetail: { page, limit },
      searchUsername,
      role,
      username,
      source,
      _id,
    } = this;
    this.GeneralInstance.toggleLoading(true);
    let res;
    if (searchUsername) {
      this.role = 'All';
      res = await this.AccountInstance.FetchDownLineSearch({
        username: searchUsername.trim(),
      });
    } else {
      res = await this.AccountInstance.FetchDownLine({
        pageOption: {
          page,
          limit,
        },
        role,
        username,
        source,
        _id,
        userId: this.AuthInstance.user._id,
        multicurrency: true,
      });
    }
    if (res.code) {
      this.checkError(res);
    } else {
      const { users, pagination, breadcrumb } = this.AccountInstance.users;
      const resultData = users ? [...users] : [];
      this.userList = resultData;
      this.startCount = pagination ? pagination.startCount : 1;
      this.BreadcrumbList = [...this.BreadcrumbDefault, ...breadcrumb];
      this.PaginationDetail.amount = pagination ? pagination.pageAmount : 0;
    }
    this.GeneralInstance.toggleLoading(false);
  }

  changePage(i: number) {
    this.PaginationDetail.page = i;
    this.fetchUsers();
  }

  handleSub(user) {
    this.prepareFetch(user);
  }

  handleBreadcrumb(user) {
    this.prepareFetch(user);
  }

  handleLevel() {
    this.PaginationDetail.page = 1;
    this.fetchUsers();
  }

  prepareFetch(user) {
    this.userId = user._id;
    this._id = user._id;
    this.username = user.username;
    this.source = user.source;
    this.PaginationDetail.page = 1;
    this.searchUsername = '';
    this.fetchUsers();
  }
}
